import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AdminModal from '../common/AdminModal';
import FormInput from '../../../shared/components/FormInput';
import FormSelect from '../../../shared/components/FormSelect';
import { USER_ROLE_ORDER, roleOptions } from '../../auth/permissions';

// Deliberately least-privileged first: a token should default the reader's eye to the
// narrowest scope. The roles themselves come from permissions.js.
const ROLE_OPTIONS = roleOptions([...USER_ROLE_ORDER].reverse());

export default function CreateApiTokenModal({ show, users, onClose, onCreate, creating }) {
  const [name, setName] = useState('');
  const [ownerId, setOwnerId] = useState('');
  const [role, setRole] = useState('');

  useEffect(() => {
    if (show) {
      setName('');
      setOwnerId('');
      setRole('');
    }
  }, [show]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onCreate({ name: name.trim(), ownerId: Number(ownerId), role });
  };

  const ownerOptions = users.map((user) => ({
    value: user.id,
    label: `${user.full_name || user.email} (${user.email})`,
  }));

  const footer = (
    <div className="d-flex justify-content-between w-100">
      <button type="button" className="btn btn-link text-muted" onClick={onClose} disabled={creating}>
        <i className="bi bi-arrow-left me-1" /> Cancel
      </button>
      <button type="submit" form="create-api-token-form" className="btn btn-primary" disabled={creating}>
        {creating ? 'Creating…' : 'Create token'}
      </button>
    </div>
  );

  return (
    <AdminModal show={show} onClose={onClose} title="Create API token" footer={footer} size="">
      <form id="create-api-token-form" onSubmit={handleSubmit}>
        <FormInput
          id="api-token-name"
          label="Integration name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Data Lake ETL"
          required
        />
        <FormSelect
          id="api-token-owner"
          label="Contact owner"
          value={ownerId}
          onChange={(e) => setOwnerId(e.target.value)}
          options={ownerOptions}
          placeholder="Select a contact…"
          helperText="Person to contact about this integration."
          required
        />
        <FormSelect
          id="api-token-role"
          label="Access role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          options={ROLE_OPTIONS}
          placeholder="Select access level…"
          helperText={(
            <>
              What this integration is allowed to do. Independent of the contact owner.
              {role === 'admin' && (
                <span className="text-warning d-block mt-1">
                  Admin role grants full organization access.
                </span>
              )}
            </>
          )}
          required
        />
      </form>
    </AdminModal>
  );
}

CreateApiTokenModal.propTypes = {
  show: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string,
    full_name: PropTypes.string,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  creating: PropTypes.bool,
};

CreateApiTokenModal.defaultProps = {
  creating: false,
};

